import { AxiosResponse } from 'axios';
import { axios } from '@repository/RequestClient';
import { PhsPaccApplyCountRs } from '@domain/rs/phs/apply/PhsApplyCountRs';
import { PACCApplyStatusRs } from '@domain/rs/phs/apply/PhsApplyStatusRs';

const paccApplyPrefix = '/phs/pacc/apply';

export default interface PhsPaccApplyRepo {
  // 개발자 역량검사 월 기본 최대 응시가능 횟수 (비로그인 시 표시)
  fetchPACCMaxApplyCount(): Promise<AxiosResponse<PhsPaccApplyCountRs>>;

  // 개발자 역량검사 가장 최근 응시 상태
  fetchPACCApplyStatus(): Promise<AxiosResponse<PACCApplyStatusRs>>;
}

export class RemotePhSPaccApplyRepo implements PhsPaccApplyRepo {
  fetchPACCMaxApplyCount(): Promise<AxiosResponse<PhsPaccApplyCountRs>> {
    return axios.get(`${paccApplyPrefix}/max-apply-chance`);
  }

  fetchPACCApplyStatus(): Promise<AxiosResponse<PACCApplyStatusRs>> {
    return axios.get(`${paccApplyPrefix}/status`);
  }
}
